export default [
  {
    id: 0,
    icon: 'fas fa-drum',
    name: 'Drum Kits',
    description: '(Drums, cymbals, racks and much more)',
    instruments: [
      {
        id: 0,
        img: 'https://gloimg.gbtcdn.com/images/pdm-product-pic/Electronic/2019/05/10/source-img/20190510143637_37273.jpg_100x100.jpg',
        name: 'SLADE 14 inch Snare Drum with Stick Strap Wrench - Red Wine 4',
        state: 'New',
        from: 'Juiz de Fora, Brazil',
        price: 5.99,
      },
      {
        id: 1,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/Effects-Cymbal-Stack/K36911000000000-00-220x220.jpg',
        name: 'Agazarian Effects Cymbal Stack',
        state: 'Used',
        from: 'Além Paraíba, Brazil',
        price: 37.99,
      },
      {
        id: 2,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/5-Piece-Complete-Drum-Set-Black/J56102000002000-00-220x220.jpg',
        name: 'Rogue 5-Piece Complete Drum Set',
        state: 'New',
        from: 'Rio de Janeiro, Brazil',
        price: 149.99,
      },
      {
        id: 3,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/SD350-Electronic-Drum-Kit-with-Mesh-Pads/J52903000000000-00-220x220.jpg',
        name: 'Simmons SD350 Electronic Drum Kit with Mesh Pads',
        state: 'New',
        from: 'Juiz de Fora, Brazil',
        price: 319.99,
      },
    ],
  },
  {
    id: 1,
    icon: 'fas fa-guitar',
    name: 'Guitars',
    description: '(Acoustic and electric guitars)',
    instruments: [
      {
        id: 4,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/Pursuit-Exotic-Concerto-CE-Myrtlewood-Myrtlewood-Acoustic-Electric-Guitar-Cinnamon-Burst/L47817000001000-00-220x220.jpg',
        name: 'Breedlove Pursuit Exotic Concerto CE Myrtlewood-Myrtlewood...',
        state: 'New',
        from: 'Wroclaw, Poland',
        price: 455.99,
      },
      {
        id: 5,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/Premier-Series-EXL-1-Hollowbody-Electric-Guitar-with-Stairstep-Tailpiece-Black/J47122000001000-00-220x220.jpg',
        name: 'D\'Angelico Premier Series EXL-1 Hollowbody Electric Guitar...',
        state: 'Used',
        from: 'Plitwice, Poland',
        price: 379.99,
      },
      {
        id: 6,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/Premier-CS-Series-Fulton-Grand-Auditorium-12-String-Acoustic-Electric-Guitar-Black/L54663000001000-00-220x220.jpg',
        name: 'D\'Angelico Premier CS Series Fulton Grand Auditorium...',
        state: 'New',
        from: 'Opole, Poland',
        price: 549.99,
      },
      {
        id: 7,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/USA-Concerto-E-Sitka-Spruce-Mahogany-Acoustic-Electric-Guitar-Cinnamon-Burst/L72172000001000-00-220x220.jpg',
        name: 'Breedlove USA Concerto E Sitka Spruce-Mahogany...',
        state: 'New',
        from: 'Gdansk,Poland',
        price: 319.99,
      },
    ],
  },
  {
    id: 2,
    icon: 'fas fa-columns',
    name: 'Pianos',
    description: '(Pianos and Musical Keyboards)',
    instruments: [
      {
        id: 8,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/Overture-2-88-Key-Console-Digital-Piano/J17210000000000-00-220x220.jpg',
        name: 'Williams Overture 2 88-Key Console Digital Piano',
        state: 'New',
        from: ' London, UK',
        price: 795.99,
      },
      {
        id: 9,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/MDG-300-Black-Micro-Grand-Digital-Piano/J19268000000000-00-220x220.jpg',
        name: 'Williams Black Stand for Williams Legato Digital Pianos',
        state: 'Used',
        from: 'Manchester, UK',
        price: 879.99,
      },
      {
        id: 10,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/CTP-88-Innovation-Digital-Piano/J14201000000000-00-220x220.jpg',
        name: 'Suzuki CTP-88 Innovation Digital Piano',
        state: 'New',
        from: 'Edimburg, UK',
        price: 949.99,
      },
      {
        id: 11,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/Allegro-III-Keyboard-Intro-Package/L48167000000000-00-220x220.jpg',
        name: 'Williams Allegro III Keyboard Intro Package',
        state: 'New',
        from: 'Glasgow, UK',
        price: 419.99,
      },
    ],
  },
  {
    id: 3,
    icon: 'fas fa-sleigh',
    name: 'Trumpets',
    description: '(All types of trumpets.)',
    instruments: [
      {
        id: 12,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/ETR-100-Series-Student-Bb-Trumpet-Lacquer/463676000420000-00-220x220.jpg',
        name: 'Etude ETR-100 Series Student Bb Trumpet',
        state: 'New',
        from: 'Juiz de Fora, Brazil',
        price: 455.99,
      },
      {
        id: 13,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/GTR-300-Student-Bb-Trumpet/J47420000000000-00-220x220.jpg',
        name: 'Giardinelli GTR-300 Student Bb Trumpet',
        state: 'New',
        from: 'Além Paraíba, Brazil',
        price: 579.99,
      },
      {
        id: 14,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/ATR-450-Vienna-Series-Intermediate-Bb-Trumpet-Silver-plated/J50836000001000-00-220x220.jpg',
        name: 'Allora ATR-450 Vienna Series Intermediate Bb Trumpet',
        state: 'Used',
        from: 'Juiz de Fora, Brazil',
        price: 549.99,
      },
      {
        id: 15,
        img: 'https://media.musiciansfriend.com/is/image/MMGS7/ETR-200-Series-Student-Bb-Trumpet-Lacquer/J50855000001000-00-220x220.jpg',
        name: 'Etude ETR-200 Series Student Bb Trumpet',
        state: 'New',
        from: 'Juiz de Fora, Brazil',
        price: 819.99,
      },
    ],
  },
];
